export default "__VITE_ASSET__8a5dbea3__"